import React from 'react';
import { CONTACT_SEARCH, PRODUCT_SEARCH, PROSPECT_SEARCH, QUOTE_SEARCH, TASK_SEARCH } from "v4/data/apiRoutes";
import { CONTACT, PRODUCT, PROSPECT, QUOTE, TASK } from "v4/data/entities";
import { useNavigation } from "v4/features/front/navigation/contexts/NavigationContext";
import SearchSection from "v4/features/front/Search/components/SearchSection";
import useGETUrlToObject from "v4/hooks/useGETUrlToObject";
import { usePolTranslation } from "v4/hooks/usePolTranslation";
import ContactsListingRowActions
    from "v4/pages/front/Contacts/components/ContactsListing/components/ContactsListingRowActions/ContactsListingRowActions";
import ProductsListingRowActions
    from "v4/pages/front/Products/components/ProductsListing/components/ProductsListingRowActions/ProductsListingRowActions";
import "./SearchPage.scss";
import ProspectsListingRowActions
    from "v4/pages/front/Prospects/components/ProspectsListing/components/ProspectsListingRowActions/ProspectsListingRowActions";
import QuotesListingRowActions
    from "v4/pages/front/Quotes/components/QuotesListing/components/QuotesListingRowActions/QuotesListingRowActions";
import TasksListingRowActions
    from "v4/pages/front/Tasks/components/TasksListing/components/TasksListingRowActions/TasksListingRowActions";

const SEARCH_CONFIG = {
    [PROSPECT]: {
        searchRouteName: PROSPECT_SEARCH,
        rowActions: ProspectsListingRowActions,
        tableClassName: "prospects",
        resultsText: "resultats_elements_prospect"
    },
    [CONTACT]: {
        searchRouteName: CONTACT_SEARCH,
        rowActions: ContactsListingRowActions,
        tableClassName: "contacts",
        resultsText: "resultats_elements_contact"
    },
    [TASK]: {
        searchRouteName: TASK_SEARCH,
        rowActions: TasksListingRowActions,
        tableClassName: "actions",
        resultsText: "resultats_elements_action"
    },
    [QUOTE]: {
        searchRouteName: QUOTE_SEARCH,
        rowActions: QuotesListingRowActions,
        tableClassName: "devis",
        resultsText: "resultats_elements_devis"
    },
    [PRODUCT]: {
        searchRouteName: PRODUCT_SEARCH,
        rowActions: ProductsListingRowActions,
        tableClassName: "articles",
        resultsText: "resultats_elements_product"
    }
};

export default function SearchPage() {
    const { t } = usePolTranslation();
    const { searchText } = useGETUrlToObject();
    const { mainNavigation } = useNavigation();

    if (!searchText) {
        return (
            <div className="page search-page">
                <div className="search-page__empty">
                    {t('make_global_search')}
                </div>
            </div>
        );
    }

    const searchableSections = mainNavigation.reduce((acc, route) => {
        const isSearchable = route.metadata?.is_global_searchable;

        if (!isSearchable) return acc;

        const config = SEARCH_CONFIG[route.search_type];

        if (!config) return acc;

        const key = route.native_identifier || `custom_${route.metadata?.id}`;
        acc.push({
            ...config,
            key,
            route,
        });

        return acc;
    }, []);

    return (
        <div className="page page-list search-page main-content__body__slide">
            <div className="page-list__content">
                <div className="table-container">
                    <p className="search-page__search-text">{t('votre_recherche')} : <span>{searchText}</span></p>
                    {searchableSections.map((section) => (
                        <SearchSection {...section} searchText={searchText}/>
                    ))}
                </div>
            </div>
        </div>
    );
}
